// Reveal-on-scroll for the cause & solution section. Content is visible without JS; with reduced motion nothing moves.
(() => {
  const init = (root) => {
    if (root.dataset.clcsReady || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.dataset.clcsReady = 'true';
    const targets = root.querySelectorAll('[data-clcs-reveal]');
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    }), { rootMargin: '0px 0px -8% 0px' });
    targets.forEach((target) => observer.observe(target));
    root.classList.add('is-ready');
  };
  const start = () => document.querySelectorAll('[data-clcs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
